import { Component, inject } from '@angular/core';
import { TariffsModuleService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TariffsModuleCreateDto,
  TariffsModuleDto,
  TariffsModuleExcelDownloadDto,
  TariffsModuleUpdateDto,
} from '../proxy/controlling/dtos/tariffs-module';
import { TARIFFSMODULE_CONFIG, TARIFFSMODULE_FIELDS } from './tariffs-module.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-tariffs-module',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TariffsModuleService, ConfirmationService],
  templateUrl: './tariffs-module.html',
  styleUrl: './tariffs-module.scss',
})
export class TariffsModule extends BaseCrudComponent<
  TariffsModuleDto,
  TariffsModuleCreateDto,
  TariffsModuleUpdateDto,
  TariffsModuleExcelDownloadDto
> {
  service = inject(TariffsModuleService);
  config = TARIFFSMODULE_CONFIG;
  fields = TARIFFSMODULE_FIELDS;

  protected prepareUpdateDto(data: any, selected: TariffsModuleDto): TariffsModuleUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TariffsModule';
  }
}
